import {highlightYellow} from './highlightYellow';
import {TemplatePurposes} from '../EmailEditor';

export const getInsuranceOptions = (d: any) => {
    const header =
        d.template_purpose === TemplatePurposes.quoted
            ? 'Life insurance plan option for'
            : 'Life insurance plan summary for';

    const IUL = `<p><strong>${header}</strong><strong> </strong><strong>${highlightYellow(d.name)}</strong></p>
<ul>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">${highlightYellow(
        d.face_amount,
    )}</span><span style="font-weight: 400;"> life, critical, chronic, and terminal illness protection for the rest of life (immediate payout in a life or qualifying health emergency)</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">${highlightYellow(
        d.cash_value,
    )} tax-free retirement cash at age ${highlightYellow(d.cash_age)}</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">${highlightYellow(
        d.monthly_premium,
    )} per month</span></li>
</ul>`;

    const GUL = `<p><strong>${header}</strong><strong> </strong><strong>${highlightYellow(d.name)}</strong></p>
<ul>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">${highlightYellow(
        d.face_amount,
    )}</span><span style="font-weight: 400;"> life, critical, chronic, and terminal illness protection for the rest of life (immediate payout in a life or qualifying health emergency)</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">${highlightYellow(
        d.monthly_premium,
    )} per month</span></li>
</ul>`;

    const Term = `<p><strong>${header}</strong><strong> </strong><strong>${highlightYellow(d.name)}</strong></p>
<ul>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">${highlightYellow(
        d.face_amount,
    )}</span><span style="font-weight: 400;"> life, critical, chronic, and terminal illness protection for ${highlightYellow(
        d.term_period,
    )} years</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">${highlightYellow(
        d.monthly_premium,
    )} per month</span></li>
</ul>`;

    if (d.product_type === 'IUL') {
        return IUL;
    }

    if (d.product_type === 'GUL') {
        return GUL;
    }

    if (d.product_type === 'Term') {
        return Term;
    }
};
